export class AxButton {
    Loading(btn: HTMLElement, classes: string = '') {
        let $btn = $(btn);
        if (!$btn.hasClass("ax-loading")) {
            $btn.prop("disabled", true).addClass(`ax-loading ${classes}`).append(`<span class="ax-btn-loading ${classes}"></span>`);
        }
    }

    StopLoading(btn: HTMLElement, classes: string = '') {
        let $btn = $(btn);
        if ($btn.hasClass("ax-loading")) {
            $btn.prop("disabled", false).removeClass(`ax-loading ${classes}`);
            $btn.find('.ax-btn-loading').remove();
        }
    }
}